import { render } from "./RoleUserForm.vue?vue&type=template&id=482b162e&ts=true"
import script from "./RoleUserForm.vue?vue&type=script&lang=ts"
export * from "./RoleUserForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__